import React, { memo, useContext, useEffect, useState } from "react";

// Redux
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// 3rd Party Libraries
import { cloneDeep, isEmpty } from "lodash";
import { Col, Row } from "react-bootstrap";
import { GrCircleInformation } from "react-icons/gr";
import { effciencyApi } from "../../../../app/services/efficiencyApi";

// Components
import ButtonComponent from "../../../../app/common-components/ButtonComponent";
import CustomModal from "../../../../app/common-components/CustomModal";
import CustomSelectDropDown from "../../../../app/common-components/CustomSelectDropDown";
import DiscardChanges from "../../../../app/common-components/DiscardChanges";
import FormCheck from "../../../../app/common-components/form/checkbox";
import Input from "../../../../app/common-components/form/input";
import Spinners from "../../../../app/common-components/Spinner";

// internal Comp
import { AppConfigContext } from "./CmdbConfig";

// Utils
import { useCommonAlert } from "../../../../app/utilities/helpers";
import { validateProject } from "./Constants";

// styles
import "../styles.scss";

const NewCmdbConfig = (props) => {

  const { callAlert, conformationPop } = props;
  const { efficiency, common } = useSelector((state) => state);
  const [selectedCriticality, setSelectedCriticality] = useState(null);
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const { managerList } = efficiency.appConfig;
  const { userName } = common.loggedUser;
  const [checkAppCode] = effciencyApi.useLazyCheckAppCodeQuery();
  const context = useContext(AppConfigContext);
  const navigate = useNavigate();
  const [postApplicationDetails] =
    effciencyApi.usePostApplicationDetailsMutation();
  const [search, setSearch] = useState({
    "Primary Manager": [],
    "Secondary Manager": [],
    "Business Department": [],
    "Business Division": [],
  });
  const [divisionOption, setDivisionOption] = useState([]);
  const [departmentOption, setDepartmentOption] = useState([]);
  const [primaryManager, setprimaryManager] = useState([]);
  const [secondaryManager, setsecondaryManager] = useState([]);
  const [businessDepartment, setbusinessDepartment] = useState([]);
  const [businessUnit, setbusinessUnit] = useState([]);
  const [btnShow, setbtnShow] = useState("");
  const [isLoading, setLoader] = useState(false);
  const [keyForRerender, setKeyForRerender] = useState(0);
  const [state, setState] = useState({
    formFields: {
      "Application Code": "",
      "Application Name": "",
      "Primary Manager": "",
      "Primary ManagerId": "",
      "Secondary Manager": "",
      "Secondary ManagerId": "",
      "Business Division": "",
      "Business Department": "",
      Criticality: "",
      Description: "",
      approvalGate: 0,
    },
    "Application CodeError": false,
    "Application NameError": false,
    "Primary ManagerError": false,
    "Secondary ManagerError": false,
    "Business DivisionError": false,
    "Business DepartmentError": false,
    CriticalityError: false,
    "Application CodeErrorMessage": "",
    "Application NameErrorMessage": "",
    "Primary ManagerErrorMessage": "",
    "Secondary ManagerErrorMessage": "",
    "Business DivisionErrorMessage": "",
    "Business DepartmentErrorMessage": "",
    CriticalityErrorMessage: "",
    modalOpen: false,
    navBtnShow: "",
    addBodyAccount: false,
    conformationPop: false,
  });
  let keysArray = [];
  let valuesArray = [];
  useEffect(() => {
    keysArray = Object.keys(
      props.businessInfoList ? props.businessInfoList : {}
    ).map((ids, index) => ({
      label: ids,
      value: ids,
      id: ids,
    }));
    setDivisionOption(keysArray);
  }, [props.businessInfoList]);

  const [getCmdbDetails] = effciencyApi.useLazyGetCmdbDetailsQuery();

  const getEditDepartment = (inputString) => {
    // Remove any empty keys
    const filteredData = Object.keys(props.businessInfoList).reduce(
      (acc, key) => {
        if (key !== "") {
          acc[key] = props.businessInfoList[key];
        }
        return acc;
      },
      {}
    );

    const mappedValues = [];

    const mapKey = Object.keys(filteredData).find(key => filteredData[key].includes(inputString));
    const mapData = filteredData[mapKey];

    if (mapData) {
      mapData.forEach((value) => {
        mappedValues.push({ label: value, value, id: value });
      });
    }

    return mappedValues;
  };

  console.log(managerList);

  function convertStringToObject(inputString, type) {
    if (type.toLowerCase() === "array") {
      return {
        label: inputString,
        value: inputString,
      };
    } else if (type.toLowerCase() === "object") {
      return [
        {
          label: inputString,
          value: inputString,
        },
      ];
    }
  }
  const getFormData = async () => {
    setLoader(true);
    try {
      const { data } = await getCmdbDetails({
        id: context.state.cmdbId,
        cacheTimeStamp: new Date().getTime(),
      });

      const {
        id,
        appCode,
        appName,
        primaryManager,
        primaryManagerId,
        secondaryManager,
        secondaryManagerId,
        businessDepartment,
        businessUnit,
        criticality,
        description,
        approvalGate,
      } = data;

      setState({
        ...state,
        formFields: {
          id,
          "Application Code": appCode,
          "Application Name": appName,
          "Primary Manager": primaryManager,
          "Primary ManagerId": primaryManagerId,
          "Secondary Manager": secondaryManager,
          "Secondary ManagerId": secondaryManagerId,
          "Business Department": businessDepartment,
          "Business Division": businessUnit,
          Criticality: criticality,
          Description: description,
          approvalGate,
        },
      });
      const EditDeptList = getEditDepartment(businessUnit);
      setDepartmentOption(EditDeptList);
      const businessUnitvalue = convertStringToObject(businessUnit, "object");
      const primaryManagervalue = convertStringToObject(
        primaryManager,
        "object"
      );
      const secondaryManagervalue = convertStringToObject(
        secondaryManager,
        "object"
      );
      const businessDepartmentvalue = convertStringToObject(
        businessDepartment,
        "object"
      );
      setprimaryManager(primaryManagervalue);
      setsecondaryManager(secondaryManagervalue);
      setbusinessUnit(businessUnitvalue);
      setbusinessDepartment(businessDepartmentvalue);
      setKeyForRerender((prevKey) => prevKey + 1);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      callCommonAlert("error", "Something went wrong. Please try again.");
      hideCommonAlert();
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    context.state.appConfigTitle === "Update CMDB Configuration" &&
      getFormData();
  }, []);

  const mapValues = (inputJson, mappingObject) => {
    const mappedValues = [];
    const filteredData2 = Object.keys(mappingObject).reduce((acc, key) => {
      if (key !== "") {
        acc[key] = mappingObject[key];
      }
      return acc;
    }, {});
    inputJson.forEach((item) => {
      const key = item.value;
      if (filteredData2[key]) {
        const values = filteredData2[key];
        values.forEach((value) => {
          if (!mappedValues.some((mappedItem) => mappedItem.value === value)) {
            mappedValues.push({ label: value, value, id: value });
          }
        });
      }
    });

    return mappedValues;
  };

  const handleOnChange = (name, selectedValue) => {
    setState((state) => ({
      ...state,
      conformationPop: true,
    }));
    if (name === "Business Department") {
      const mappedResult = mapValues([selectedValue], props.businessInfoList);
      setDepartmentOption(mappedResult);

      setSearch({
        ...search,
        [name]: mappedResult,
      });
      setState((state) => ({
        ...state,
        formFields: {
          ...state.formFields,
          "Business Division": [],
        },
      }));
      setbusinessUnit([]);
      setKeyForRerender((prevKey) => prevKey + 1);
    }

    if (state[`${name}Error`]) {
      setState((state) => ({
        ...state,
        [`${name}Error`]: false,
        [`${name}ErrorMessage`]: "",
      }));
    }
    if (name === "Primary Manager") {
      if (state[`Secondary ManagerErrorMessage`] === "Primary Manager and Secondary Manager should not be the same" && state[`Secondary ManagerError`]) {
        setState((state) => ({
          ...state,
          [`Secondary ManagerError`]: false,
          [`Secondary ManagerErrorMessage`]: "",
        }));
      }
    }
    let value = selectedValue;
    if (Array.isArray(value)) {
      value = isEmpty(selectedValue) ? "" : selectedValue[0];
    }
    value?.id
      ? setState((state) => ({
        ...state,
        formFields: {
          ...state.formFields,
          [`${name}Id`]: value.id,
          [name]: value.value,
        },
      }))
      : setState((state) => ({
        ...state,
        formFields: {
          ...state.formFields,
          [name]:
            Array.isArray(selectedValue) && selectedValue.length === 0
              ? ""
              : selectedValue,
        },
      }));
    if (name === "Criticality") {
      setState((state) => ({
        ...state,
        formFields: {
          ...state.formFields,
          [name]:
            Array.isArray(selectedValue) && selectedValue.length === 0
              ? ""
              : selectedValue.value,
        },
      }));
    }
  };
  const handleCheckboxChange = (e) => {
    setState((state) => ({
      ...state,
      formFields: {
        approvalGate: e.target.checked ? 1 : 0,
      },
    }));
  };

  function validateAlphaNumericSpace(value) {
    if (/^[a-zA-Z][a-zA-Z0-9 ]+$/.test(value)) {
      return true;
    }
    return false;
  }
  function validateAlphaNumericAllowSpace(value) {
    const regex = /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/;
    if (regex.test(value)) {
      return true;
    }
    return false;
  }

  const handleOnChangeCriticality = (selectedOption) => {
    setSelectedCriticality(selectedOption);
  };
  const validateForm = () => {
    let tmpFormFields = cloneDeep(state.formFields);
    let formValidation = true;

    Object.keys(tmpFormFields).forEach((key) => {
      if (tmpFormFields[key] === "" && key != "approvalGate") {
        setState((state) => ({
          ...state,
          [`${key}Error`]: true,
          [`${key}ErrorMessage`]: `${key} should not be empty`,
        }));
        formValidation = false;
      }
    });
    if ((tmpFormFields["Description"] !== "" &&
      tmpFormFields["Description"].length < 5) ||
      tmpFormFields["Description"].length > 1000) {
      setState((state) => ({
        ...state,
        "DescriptionError": true,
        "DescriptionErrorMessage": "Description must be 5 to 1000 characters long",
      }));
      formValidation = false;
    }
    if (tmpFormFields["Application Code"] === "0") {
      setState((state) => ({
        ...state,
        "Application CodeError": true,
        "Application CodeErrorMessage": "Application Code should not be 0",
      }));
      formValidation = false;
    } else if (
      tmpFormFields["Application Code"] !== "" &&
      tmpFormFields["Application Code"].length < 2 ||
      tmpFormFields["Application Code"].length > 10
    ) {
      setState((state) => ({
        ...state,
        "Application CodeError": true,
        "Application CodeErrorMessage": (
          <div className="informationIconStyle">
            <div className="AppConfigTooltip">
              <span className="error">
                Please enter a valid Application Code{" "}
              </span>
              <GrCircleInformation />
              <span className="AppConfigtooltiptext">
                Application Code must be 2 to 10 characters long
              </span>
            </div>
          </div>
        ),
      }));
      formValidation = false;
    } else if (
      tmpFormFields["Application Code"] !== "" &&
      !validateProject(tmpFormFields["Application Code"])
    ) {
      setState((state) => ({
        ...state,
        "Application CodeError": true,
        "Application CodeErrorMessage": (
          <div className="informationIconStyle">
            <div className="AppConfigTooltip">
              <span className="error">
                Please enter a valid Application Code{" "}
              </span>
              <GrCircleInformation />
              <span className="AppConfigtooltiptext">
                First letter of the Application Code should be alphabet and
                remaining should be alphanumeric
              </span>
            </div>
          </div>
        ),
      }));
      formValidation = false;
    }
    if (tmpFormFields["Application Name"].trim() === "") {
      setState((state) => ({
        ...state,
        "Application NameError": true,
        "Application NameErrorMessage": "Application Name should not be empty",
      }));
      formValidation = false;
    } else if (tmpFormFields["Application Name"] === "0") {
      setState((state) => ({
        ...state,
        "Application NameError": true,
        "Application NameErrorMessage": "Application Name should not be 0",
      }));
      formValidation = false;
    } else if (
      tmpFormFields["Application Name"].length < 3 ||
      tmpFormFields["Application Name"].length > 100
    ) {
      setState((state) => ({
        ...state,
        "Application NameError": true,
        "Application NameErrorMessage": (
          <div className="informationIconStyle">
            <div className="AppConfigTooltip">
              <span className="error">Please enter a valid Application Name </span>
              <GrCircleInformation />
              <span className="AppConfigtooltiptext">
                Application Name must be 3 to 100 characters long
              </span>
            </div>
          </div>
        ),
      }));
      formValidation = false;
    } else if (!validateAlphaNumericAllowSpace(tmpFormFields["Application Name"].trim())) {
      setState((state) => ({
        ...state,
        "Application NameError": true,
        "Application NameErrorMessage": (
          <div className="informationIconStyle">
            <div className="AppConfigTooltip">
              <span className="error">Please enter a valid Application Name </span>
            </div>
          </div>
        ),
      }));
      formValidation = false;
    }


    if (
      tmpFormFields["Business Division"] !== "" &&
      tmpFormFields["Business Division"]?.length < 2
    ) {
      setState((state) => ({
        ...state,
        "Business DivisionError": true,
        "Business DivisionErrorMessage":
          "Business Division should not be empty",
      }));
      formValidation = false;
    }
    if (
      tmpFormFields["Primary Manager"] !== "" &&
      tmpFormFields["Secondary Manager"] !== "" &&
      tmpFormFields["Primary Manager"] === tmpFormFields["Secondary Manager"]
    ) {
      setState((state) => ({
        ...state,
        "Secondary ManagerError": true,
        "Secondary ManagerErrorMessage":
          "Primary Manager and Secondary Manager should not be the same",
      }));
      formValidation = false;
    }
    if (
      tmpFormFields["Primary Manager"] !== "" &&
      tmpFormFields["Secondary Manager"] !== "" &&
      tmpFormFields["Primary Manager"] !== tmpFormFields["Secondary Manager"]
    ) {
      setState((state) => ({
        ...state,
        "Secondary ManagerError": false,

      }));
    }
    return formValidation;
  };

  const handleSubmit = async () => {
    const validation = validateForm();
    if (validation) {
      const {
        "Application Code": appCode,
        "Application Name": appName,
        "Primary Manager": primaryManager,
        "Primary ManagerId": primaryManagerId,
        "Secondary Manager": secondaryManager,
        "Secondary ManagerId": secondaryManagerId,
        "Business Division": businessUnit,
        "Business Department": businessDepartment,
        Criticality: criticality,
        Description: description,
        approvalGate,
      } = state.formFields;

      const cacheTimeStamp = new Date().getTime();
      const id = state.formFields.id ? state.formFields.id : 0;

      const payload = {
        id: state.formFields.id ? state.formFields.id : "",
        appCode,
        appName,
        primaryManager,
        secondaryManager,
        primaryManagerId,
        businessDivision: businessUnit,
        businessDepartment,
        secondaryManagerId,
        approvalGate,
        description,
        criticality,
      };

      postApplicationDetails({ payload, userName }).then((data) => {

        if (data?.data?.statusCodeValue == 200) {
          callAlert("success", data?.data?.body);
          const payload = props.getpayload();
          props.fetchApiData(0, 10, payload);
          context.setState((state) => ({
            ...state,
            applicationConfig: false,
            loadPage: !state.loadPage,
          }));
        } else if (data?.data?.statusCodeValue == 400) {
          callAlert("error", data?.data?.body);
          const payload = props.getpayload();
          props.fetchApiData(0, 10, payload);
        } else {
          callAlert("error", "Something went wrong please try again.");
        }
      });
    }
  };

  const handleSearch = (name, searchString, IterationList) => {
    setState((state) => ({
      ...state,
      formFields: {
        ...state.formFields,
        [`${name}Id`]: searchString,
        [name]: searchString,
      },
    }));

    const matchedUsers = IterationList.filter((item) =>
      item.label.toLowerCase().includes(searchString.toLowerCase())
    );
    setSearch({
      ...search,
      [name]: matchedUsers,
    });
  };
  const cmdbCriticality = [
    {
      label: "CAT-1",
      value: "CAT-1",
    },
    {
      label: "CAT-2",
      value: "CAT-2",
    },
    {
      label: "CAT-3",
      value: "CAT-3",
    },
    {
      label: "CAT-4",
      value: "CAT-4",
    },
  ];

  useEffect(() => {
    const selectedOption = cmdbCriticality.find(
      (option) => option.value === state.formFields.Criticality
    );
    setSelectedCriticality(selectedOption);
  }, [state.formFields.Criticality]);

  const addmodalHide = () => {
    context.setState((state) => ({
      ...state,
      applicationConfig: false,
    }));
    setState((state) => ({
      ...state,
      conformationPop: false,
    }));
  };
  const addmodalCancelAccount = () => {
    setState((state) => ({
      ...state,
      addBodyAccount: true,
    }));
  };
  const addBodyCloseAccount = () => {
    setState({
      ...state,
      addBodyAccount: false,
    });
  };
  const addBodyCancelAccount = () => {
    return (
      <>
        <DiscardChanges title={context.state.appConfigTitle === 'New CMDB Configuration' ? 'add' : 'edit'} discardClick={addmodalHide} cancelClick={addBodyCloseAccount} />
      </>
    );
  };



  return (
    <>
      {isLoading ? (
        <Spinners />
      ) : (
        <div className="config-wrap bg-white">
          <h4 className="sectitle newhead">{context.state.appConfigTitle}</h4>
          <div className="confingform">
            <div className="confingform-wrap">
              <div className="row">
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                  <div className="confingformcol appGroupWidth appConfigAdd first-col">
                    <Input
                      label={"Application Details*"}
                      error={state["Application CodeError"]}
                      type={"text"}
                      name={"Application Code"}
                      value={state?.formFields?.["Application Code"]}
                      placeholder={"Enter Application Code"}
                      data-testid="applicationCodeInput"
                      containerClassName={
                        "appConfigAddinput frmgroup validate default-input col-6 "
                      }
                      minLength={2}
                      maxLength={10}
                      autoComplete={"off"}
                      errorMessage={state["Application CodeErrorMessage"]}
                      onChange={(e) => {
                        handleOnChange(e.target.name, e.target.value.trim());
                      }}
                    />
                  </div>
                  <div className="confingformcol appGroupWidth appConfigAdd second-col">
                    <CustomSelectDropDown
                      id="Primary Manager"
                      labelName={"Owner Details*"}
                      customClassName="notFocus"
                      options={managerList}
                      onSearch={(searchString) =>
                        handleSearch(searchString, managerList)
                      }
                      value={primaryManager ? primaryManager : managerList.filter(
                        (item) =>
                          item.value === state.formFields["Primary Manager"]
                      )}
                      onChange={(value) =>
                        handleOnChange("Primary Manager", value)
                      }
                      name={"Primary Owner"}
                      error={state["Primary ManagerError"]}
                      errorMessage={state["Primary ManagerErrorMessage"]}
                    //defaultValue={primaryManager}
                    />
                  </div>
                  <div className="confingformcol appGroupWidth appConfigAdd">
                    <CustomSelectDropDown
                      labelName={"Group Details*"}
                      id="Business Department"
                      options={divisionOption}
                      customClassName="notFocus"
                      onSearch={(searchString) =>
                        handleSearch(searchString, divisionOption)
                      }
                      value={divisionOption.filter(
                        (item) =>
                          item.value === state.formFields["Business Department"]
                      )}
                      onChange={(value) => {
                        handleOnChange("Business Department", value);
                      }}
                      name={"Business Department"}
                      error={state["Business DepartmentError"]}
                      errorMessage={state["Business DepartmentErrorMessage"]}
                      defaultValue={businessDepartment}
                    />
                  </div>
                  <div className="confingformcol appGroupWidth appConfigAdd">
                    <CustomSelectDropDown
                      options={cmdbCriticality}
                      labelName={"Criticality*"}
                      name={"Criticality"}
                      error={state["CriticalityError"]}
                      errorMessage={state["CriticalityErrorMessage"]}
                      value={selectedCriticality}
                      onChange={(value) => {
                        handleOnChangeCriticality(value);
                        handleOnChange("Criticality", value);
                      }}
                    />
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 ">
                  <div className="confingformcol appGroupWidth appConfigAdd second-col1">
                    <Input
                      // label={"Manager Details"}
                      // customlabelClassName={"xAxisLabel invisible "}
                      error={state["Application NameError"]}
                      type={"text"}
                      name={"Application Name"}
                      placeholder={"Enter Application Name"}
                      data-testid="applicationNameInput"
                      value={state.formFields["Application Name"]}
                      autoComplete={"off"}
                      containerClassName={
                        "appConfigAddinput frmgroup validate default-input col-6 "
                      }
                      onKeyPress={(e) => {
                        // Prevent space as the first character
                        if (e.target.value === "" && e.key === " ") {
                          e.preventDefault();
                        }
                      }}
                      minLength={3}
                      maxLength={100}
                      errorMessage={state["Application NameErrorMessage"]}
                      onChange={(e) => {
                        const { name, value } = e.target;
                        // Trim spaces from start and end but allow spaces between words
                        const trimmedValue = value.trimStart();
                        handleOnChange(name, trimmedValue);
                      }}
                    />
                  </div>
                  <div className="confingformcol appGroupWidth appConfigAdd  second-col2">
                    <label className="xAxisLabel invisible">
                      Manager Details
                    </label>
                    <CustomSelectDropDown
                      label="Group Details"
                      id="Secondary Manager"
                      customClassName="notFocus"
                      labelClassName={"labelHidden"}
                      customlabelClassName={"xAxisLabel invisible "}
                      options={managerList}
                      onSearch={(searchString) =>
                        handleSearch(searchString, managerList)
                      }
                      value={secondaryManager ? secondaryManager : managerList.filter(
                        (item) =>
                          item.value === state.formFields["Secondary Manager"]
                      )}
                      onChange={(value) =>
                        handleOnChange("Secondary Manager", value)
                      }
                      handleInputChange={(selected) =>
                        secondaryCSPInputChange(selected)
                      }
                      name={"Secondary Owner"}
                      error={state["Secondary ManagerError"]}
                      errorMessage={state["Secondary ManagerErrorMessage"]}
                    //defaultValue={secondaryManager}
                    />
                  </div>
                  <div className="confingformcol appGroupWidth appConfigAdd  second-col3">
                    <label className="xAxisLabel invisible">
                      Manager Details
                    </label>
                    <CustomSelectDropDown
                      id="Business Division"
                      options={departmentOption}
                      keyForRerender={keyForRerender}
                      label={"Group Details"}
                      labelClassName={"labelHidden"}
                      customlabelClassName={"xAxisLabel invisible "}
                      customClassName="notFocus"
                      defaultValue={businessUnit}
                      onSearch={(searchString) =>
                        handleSearch(searchString, departmentOption)
                      }
                      value={
                        departmentOption &&
                          state.formFields["Business Division"]
                          ? departmentOption.filter(
                            (item) =>
                              item.value ===
                              state.formFields["Business Division"]
                          )
                          : []
                      }
                      onChange={(value) =>
                        handleOnChange("Business Division", value)
                      }
                      name={"Business Division"}
                      error={state["Business DivisionError"]}
                      errorMessage={state["Business DivisionErrorMessage"]}
                    />
                  </div>
                  <div className="approval_container checkBox">
                    {props.page == "efficiency" ? (
                      <>
                        <FormCheck
                          name={"approvalGate"}
                          checked={state.formFields.approvalGate}
                          onChange={(e) =>
                            handleOnChange(
                              e.target.name,
                              Number(e.target.checked)
                            )
                          }
                          bottomTitle={
                            " Is authorization required for all requests?"
                          }
                        />
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                  <div className="confingformcol appGroupWidth appConfigAdd first-col">
                    <label >Description<span className="RedHighlight">*</span></label>
                    <div className="error errorAlighn">
                      {state["DescriptionErrorMessage"]}
                    </div>
                    <textarea
                      rows="17"
                      cols="23"
                      containerClassName="frmgroup w-100 mt-4 vrs validate default-input"
                      data-testid="descriptionTextArea"
                      id="Description"
                      style={
                        state["DescriptionErrorMessage"]
                          ? { border: "1px solid red" }
                          : {}
                      }
                      error={state["DescriptionError"]}
                      type={"text"}
                      name={"Description"}
                      placeholder={"Enter Description"}
                      minLength={5}
                      maxLength={1000}
                      value={state.formFields["Description"]}
                      autoComplete={"off"}
                      errorMessage={state["DescriptionErrorMessage"]}
                      onChange={(e) => {
                        handleOnChange(e.target.name, e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="">
                <Row>
                  <Col></Col>
                  <Col></Col>
                </Row>
              </div>

              <div className="btnwrap">
                <ButtonComponent
                  text="Cancel"
                  className="cancelBtnStyle"
                  data-testid="cancelBtn"
                  onClick={() => {
                    if (state.conformationPop) {
                      addmodalCancelAccount();
                    } else {
                      addmodalHide();
                    }
                  }}
                />
                <ButtonComponent text="Save" data-testid="saveBtn" onClick={handleSubmit} />
              </div>
            </div>
          </div>
        </div>
      )}
      <CustomModal
        modalOpen={state.addBodyAccount}
        modalBody={addBodyCancelAccount}
        modalHide={addmodalCancelAccount}
        closeBtn={true}
        closeBtnFuc={addBodyCloseAccount}
      />
    </>
  );
};

export default memo(NewCmdbConfig);